import { Flow } from "../types";
import { ASSISTED_SALES } from "./assistedSales";
import { R1_SELF_SERVICE } from "./r1";
import { S1_SELF_SERVICE } from "./s1";
import { VRB_SELF_SERVICE } from "./vrb";
import { ZDP_SELF_SERVICE } from "./zdp";
import { ZSP_PROCESS } from "./zsp";
import { TCR_PROCESS } from "./tcr";
import { MS_SELF_SERVICE } from "./ms";
import { PS_PROCESS_CONTRACT, PS_PROCESS_REQUEST } from "./ps";
import { ADD_INFORMATION } from "./addInformation";
import { CANCEL } from "./cancel";
import { ASSIGNED_TO_CORE_SIGNED } from "./assignedToCoreSigned";
import { S3_NO_SELF_SERVICE, S3_SELF_SERVICE } from "./s3";

export const CONTRACT_PROCESSES: {
  [x: string]: {
    NO_SELF_SERVICE_REQUEST?: Flow;
    NO_SELF_SERVICE?: Flow;
    SELF_SERVICE?: Flow;
    SELF_SERVICE_REQUEST?: Flow;
    ADD_INFORMATION?: Flow;
    CANCEL?: Flow;
    ASSIGNED_TO_CORE_SIGNED?: Flow;
  };
} = {
  fallback: {
    NO_SELF_SERVICE: ASSISTED_SALES,
    ADD_INFORMATION: ADD_INFORMATION,
    ASSIGNED_TO_CORE_SIGNED: ASSIGNED_TO_CORE_SIGNED,
    CANCEL: CANCEL,
  },
  S1: {
    SELF_SERVICE: S1_SELF_SERVICE,
  },
  S2: {
    SELF_SERVICE: S1_SELF_SERVICE,
  },
  S3: {
    NO_SELF_SERVICE: S3_NO_SELF_SERVICE,
    SELF_SERVICE: S3_SELF_SERVICE,
  },
  S4: {
    SELF_SERVICE: S1_SELF_SERVICE,
  },
  VRB: {
    SELF_SERVICE: VRB_SELF_SERVICE,
  },
  R1: {
    SELF_SERVICE: R1_SELF_SERVICE,
  },
  R2: {
    SELF_SERVICE: R1_SELF_SERVICE,
  },
  R3: {
    SELF_SERVICE: R1_SELF_SERVICE,
  },
  ZDP: {
    SELF_SERVICE: ZDP_SELF_SERVICE,
  },
  ZSP: {
    NO_SELF_SERVICE: ZSP_PROCESS,
    SELF_SERVICE: ZSP_PROCESS,
  },
  MS: {
    SELF_SERVICE: MS_SELF_SERVICE,
  },
  PS: {
    NO_SELF_SERVICE: PS_PROCESS_CONTRACT,
    SELF_SERVICE: PS_PROCESS_CONTRACT,
  },
};

export const REQUEST_PROCESSES: {
  [x: string]: {
    NO_SELF_SERVICE?: Flow;
    SELF_SERVICE?: Flow;
    ADD_INFORMATION?: Flow;
    CANCEL?: Flow;
  };
} = {
  fallback: {
    NO_SELF_SERVICE: ASSISTED_SALES,
    ADD_INFORMATION: ADD_INFORMATION,
    CANCEL: CANCEL,
  },
  TCR: {
    SELF_SERVICE: TCR_PROCESS,
    NO_SELF_SERVICE: TCR_PROCESS,
  },
  PS: {
    NO_SELF_SERVICE: PS_PROCESS_REQUEST,
    SELF_SERVICE: PS_PROCESS_REQUEST,
  },
};
